export default __webpack_public_path__ + "static/media/nextIcon.32fb142c.svg";